import { advanceSearchConstants } from '../_constants/advance-search.constants';

import { 
  setIsFetching,
  filterSearchNavResult, 
  resetSearchNavResult,
  setDefaultQueriesAdvanceSearch
 } from '../_utils/advance-search.utils';

const initialState = {
  filters: {
    isFetching: false,
    data: null,
    errorMessage: null,
  },
  currentHeaders: [],
  defaultHeaders: [
    'charts', 
    'riskLevel',
    'morningStarRating',
    'nav',
    'performance'
  ],
  searchResponse: {
    isFetching: false,
    errorMessage: null,
    currentPage: 1,
    totalPage: 1,
    data: []
  },
  searchNavResults: {
    isFetching: false,
    navs: [],
    errorMessage: null
  },
  navResponse: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  tableHeaders: [
    {
      header: 'ชื่อกองทุน',
      sortKey: 'fundCode',
      section: 'main'
    },
    {
      header: 'Chart',
      sortKey: 'charts',
      section: 'other'
    },
    {
      header: 'ความเสี่ยง',
      sortKey: 'riskLevel',
      section: 'other'
    },
    {
      header: 'Morningstar rating',
      sortKey: 'morningStarRating',
      section: 'other'
    },
    {
      header: 'NAV',
      sortKey: 'nav',
      section: 'other'
    },
    {
      header: '%UNIT Change',
      sortKey: 'unitChange',
      section: 'other'
    },
    {
      header: 'เงินเข้าออก',
      sortKey: 'fundFlow',
      section: 'other'
    },
    {
      header: 'ผลตอบแทน',
      sortKey: 'performance',
      section: 'other'
    }
  ],
  navDate: '1Y',
  defaultQueries: null,
  queries: {
    categoryCode: [],
    dividendPolicy: null,
    fundTypes: [],
    topHoldingType: 'I',
    includeTopHoldngs : [],
    excludeTopHoldngs : [],
    returnPercentage: null,
    returnDateType: '1Y',
    morningStarRatings : [],
    investorRatings : [],
    purchaseFee : null,
    currencyPolicy : null,
    company : [],
    riskLevels : [],
    sortBy: 'performance',
    sortType: 'd',
    pageSize: 20
  },
  colors: ['g-bg-red', 'g-bg-purple', 'g-bg-green', 'g-bg-blue', 'g-bg-pink', 'g-bg-cyan', 'g-bg-orange', 'g-bg-teal']
};

const advanceSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case advanceSearchConstants.UPDATE_ADVANCE_SEARCH_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach(attribute => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case 'sortBy': {
            if (value === 'nav' || value === 'riskLevel') {
              updateAttribute['sortType'] =  state.queries.sortBy === value && state.queries.sortType !== 'd' ? 'd' : 'a'
            } else {
              updateAttribute['sortType'] =  state.queries.sortBy === value && value && state.queries.sortType !== 'a' ? 'a' : 'd'
            }
            updateAttribute['sortBy'] = value;
            break;
          };
          case 'pageSize': {
            if (value !== state.queries.pageSize) {
              updateAttribute['pageSize'] = value
            }
            break;
          }
          default: updateAttribute[attribute] = value; 
            break;
        };
      })
      
      return {
        ...state,
        queries: {
          ...state.queries,
          ...updateAttribute
        },
        searchResponse: {
          ...state.searchResponse,
          currentPage: 1
        }
      }
    };
    case advanceSearchConstants.RESET_QUERIES_ADVANCE_SEARCH:
      return {
        ...state,
        queries: state.defaultQueries
      };
    case advanceSearchConstants.UPDATE_DEFAULT_QUERIES_ADVANCE_SEARCH:
      return {
        ...state,
        queries: setDefaultQueriesAdvanceSearch(state.queries, action.payload),
        defaultQueries: setDefaultQueriesAdvanceSearch(state.queries, action.payload)
      };
    case advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_START:
      return {
        ...state,
        filters: {
          ...state.filters,
          isFetching: true
        }
      };
    case advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_SUCCESS:
      return {
        ...state,
        filters: {
          ...state.filters,
          isFetching: false,
          data: action.payload,
          errorMessage: null,
        }
      };
    case advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_FAILURE:
      return {
        ...state,
        filters: {
          ...state.filters,
          isFetching: false,
          data: null,
          errorMessage: action.payload,
        }
      };
    case advanceSearchConstants.FETCH_ADVANCE_SEARCH_START:
      return {
        ...state,
        searchResponse: {
          ...state.searchResponse,
          isFetching: true
        }
      };
    case advanceSearchConstants.FETCH_ADVANCE_SEARCH_SUCCESS:
      return {
        ...state,
        searchResponse: {
          ...state.searchResponse,
          isFetching: false,
          errorMessage: null,
          totalPage: action.payload?.totalPage ?? 1,
          currentPage: action.payload?.currentPage ?? 1,
          data: action.payload?.items ?? []
        }
      };
    case advanceSearchConstants.FETCH_ADVANCE_SEARCH_FAILURE:
      return {
        ...state,
        searchResponse: {
          ...state.searchResponse,
          isFetching: false,
          errorMessage: action.payload,
          currentPage: 1,
          totalPage: 1,
          data: []
        }
      }
    case advanceSearchConstants.UPDATE_NAV_DATE_ADVANCE_SEARCH:
      return {
        ...state,
        navDate: action.payload
      };
    case advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_START:
      return {
        ...state,
        searchNavResults: setIsFetching(state.searchNavResults),
        navResponse: {
          ...state.navResponse,
          isFetching: true
        }
      };
    case advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_SUCCESS:
      return {
        ...state,
        searchNavResults: filterSearchNavResult(state.searchNavResults, action.payload),
        navResponse: {
          ...state.navResponse,
          isFetching: false,
          data: action.payload ?? [],
          errorMessage: null
        }
      };
    case advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_FAILURE:
      return {
        ...state,
        searchNavResults: resetSearchNavResult(state.searchNavResults, action.payload),
        navResponse: {
          ...state.navResponse,
          isFetching: false,
          data: [],
          errorMessage: action.payload
        }
      };
    case advanceSearchConstants.UPDATE_CURRENT_PAGE_SEARCH:
      return {
        ...state,
        searchResponse: {
          ...state.searchResponse,
          currentPage: action.payload ?? 1
        }
      };
    case advanceSearchConstants.UPDATE_TABLE_COLUMN:
      return {
        ...state,
        currentHeaders: action.payload ?? [] 
      };
    default:
      return state;
  }
};

export default advanceSearchReducer;
